module.exports = __webpack_public_path__ + "img/logo1.5e2faf49.png";